module.exports = __webpack_public_path__ + "static/img/foto1.5e3f459.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotos instalaciones/foto1.png
// module id = h5fd
// module chunks = 0